<!-- Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. -->

<div
	class="container {{ containerDimensionClass }}"
	[ngClass]="{ 'show-border': showBorder }"
	*ngIf="file"
	(click)="imageClickHandler()"
>
	<ng-container [ngSwitch]="this.state$ | async">
		<!-- Loading state -->
		<ng-container *ngSwitchCase="fileViewState.Loading">
			<div class="loading-background {{ containerDimensionClass }}"></div>
			<mat-status-indicator
				class="loading-indicator"
				[state]="spinnerState.InProgress"
				[spinnerMode]="'indeterminate'"
				[scalePercent]="50"
			>
			</mat-status-indicator>
		</ng-container>
		<!-- Error state -->
		<ng-container *ngSwitchCase="fileViewState.Error">
			<div class="loading-background {{ containerDimensionClass }}"></div>
			<mat-status-indicator
				class="loading-indicator"
				[state]="spinnerState.Failure"
				[spinnerMode]="'indeterminate'"
				[scalePercent]="50"
			>
			</mat-status-indicator>
		</ng-container>
		<ng-container *ngSwitchDefault>
			<!-- Default state -->
			<div
				[ngSwitch]="file.view.type"
				[ngClass]="{ 'attachment-selected': selected.value }"
				class="file-container"
			>
				<ng-container *ngSwitchCase="fileType.Image">
					<img [src]="url" class="{{ imageDimensionClass }}" *ngIf="url" draggable="false" />
					<mat-icon [ngClass]="[matIconClass]" *ngIf="!url">image</mat-icon>
				</ng-container>
				<ng-container *ngSwitchCase="fileType.Audio">
					<mat-icon [ngClass]="[matIconClass]">music_note</mat-icon>
				</ng-container>
				<ng-container *ngSwitchCase="fileType.Video">
					<mat-icon [ngClass]="[matIconClass]">movie</mat-icon>
				</ng-container>
				<ng-container *ngSwitchCase="fileType.Pdf">
					<mat-icon [ngClass]="[matIconClass]">picture_as_pdf</mat-icon>
				</ng-container>
				<ng-container *ngSwitchCase="fileType.Text">
					<mat-icon [ngClass]="[matIconClass]">text_snippet</mat-icon>
				</ng-container>
				<ng-container *ngSwitchDefault>
					<mat-icon [ngClass]="[matIconClass]">description</mat-icon>
				</ng-container>
			</div>

			<mat-checkbox
				class="round-checkbox"
				[formControl]="selected"
				*ngIf="(state$ | async) === fileViewState.Selection && selected.value"
			></mat-checkbox>
		</ng-container>
	</ng-container>
</div>
